complete = (data, done) ->
  Application.publish("event:completed") {}

open = ->

exit = ->

commands = (next) -> { complete, open, exit }

receiveMessage = (event) ->
  origin = event.origin or event.originalEvent.origin
  commands = event.data
  try
    eval commands
  catch err
    # console.error "Could not execute command", commands, err

window.addEventListener("message", receiveMessage, false)
opener = window.opener or window.parent
opener?.postMessage "Backbone.Events.trigger('lesson-ready');", '*'

module.exports = { type: "lesson", commands }

